export default __webpack_public_path__ + "static/media/ofline-white.433a8c41.svg";